import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Paper, Stack, TextField, Button, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import store from '../store';

const Login = observer(() => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await store.login(username, password);
      if (store.currentUser?.role === 'admin') navigate('/admin');
      else navigate('/apply');
    } catch (e) {}
  };

  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      minHeight="100vh"
      sx={{ 
        background: '#ffffff',
        padding: 2
      }}
    >
      <Paper 
        sx={{ 
          p: 4, 
          width: { xs: '100%', sm: 420 },
          maxWidth: 420,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          borderRadius: 2
        }}
        elevation={8}
      >
        <Typography variant="h5" gutterBottom align="center" sx={{ mb: 3, fontWeight: 600 }}>
          用户登录
        </Typography>
        {store.authError && <Alert severity="error" sx={{ mb: 2 }}>{store.authError}</Alert>}
        <form onSubmit={onSubmit}>
          <Stack spacing={3}>
            <TextField 
              label="用户名" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              fullWidth 
              variant="outlined"
              size="medium"
            />
            <TextField 
              label="密码" 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              fullWidth 
              variant="outlined"
              size="medium"
            />
            <Button 
              type="submit" 
              variant="contained" 
              disabled={store.authLoading}
              size="large"
              sx={{ 
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 600
              }}
            >
              {store.authLoading ? '登录中...' : '登录'}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
});

export default Login;


